// extracted by mini-css-extract-plugin
export default {"headerWrap":"MyPageHeader_headerWrap__FoBzc","icon":"MyPageHeader_icon__ysbzm"};